import React from 'react';
import { FaCopy } from 'react-icons/fa';
import QRCode from 'react-qr-code';
import { toast } from 'react-toastify';

import './QrCode.scss';

export default function QrCode({ value, description }) {
	return (
		<div className="qrcode-container">
			<QRCode
				value={value}
				className="qrcode"
			/>
			<div className="description">
				<FaCopy
					className="copy"
					title="Copiar"
					onClick={() => {
            navigator.clipboard.writeText(value);
						toast.success('Copiado para a área de transferência!');
					}}
          />
          <span>{description}</span>
			</div>
		</div>
	);
}
